import { render } from "./RegisterStep2.view.vue?vue&type=template&id=a89ef9cc"
import script from "./RegisterStep2.view.vue?vue&type=script&lang=js"
export * from "./RegisterStep2.view.vue?vue&type=script&lang=js"

import "./RegisterStep2.view.vue?vue&type=style&index=0&id=a89ef9cc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__